import React, { createContext, useContext, ReactNode, useMemo } from 'react'

interface PreviousPageContextProps {
  previousPage: string
  setPreviousPage: React.Dispatch<React.SetStateAction<string>>
}

const PreviousPageContext = createContext<PreviousPageContextProps | undefined>(undefined)

export const PreviousPageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [previousPage, setPreviousPage] = React.useState<string>('')

  const value = useMemo(() => {
    return {
      previousPage,
      setPreviousPage,
    }
  }, [previousPage, setPreviousPage])

  return <PreviousPageContext.Provider value={value}>{children}</PreviousPageContext.Provider>
}

export const usePreviousPage = () => {
  const context = useContext(PreviousPageContext)
  if (!context) {
    throw new Error('usePreviousPage must be used within a PreviousPageProvider')
  }
  return context
}
